import { components, OptionProps, SingleValueProps } from 'react-select'
import { SelectComponents } from 'react-select/dist/declarations/src/components'

import { DefaultInputWithTestId } from '@/lib/components/Select/CustomSelectComponents'

const { Option, SingleValue } = components

const DefaultSingleValue = ({
	children,
	...props
}: SingleValueProps<unknown>) => {
	return <SingleValue {...props}>{children}</SingleValue>
}

const DefaultNoOptionMessage = ({
	children,
	...props
}: SingleValueProps<unknown>) => {
	return <SingleValue {...props}>{children}</SingleValue>
}

const DefaultOption = ({ children, ...props }: OptionProps<unknown, any>) => {
	return <Option {...props}>{children}</Option>
}

/**
 * This object represents the main logic for react-select customization,
 * for more information please visit https://react-select.com/components
 */

export const getCustomComponents = (components: SelectComponents) => {
	const { SingleValue, NoOptionsMessage, Option, ...otherComponents } =
		components || {}

	return {
		SingleValue: SingleValue || DefaultSingleValue,
		Option: Option || DefaultOption,
		NoOptionsMessage: NoOptionsMessage || DefaultNoOptionMessage,
		Input: DefaultInputWithTestId,
		...otherComponents,
	}
}
